export const SET_ORG_PROFILE_INFO = 'SET_ORG_PROFILE_INFO';
export const SET_ORG_IS_PROGRESS = 'SET_ORG_IS_PROGRESS';
export const SET_ORG_REQUEST_CHANGE_INPROGRESS = 'SET_ORG_REQUEST_CHANGE_INPROGRESS';
